<div class="abp-md-form">
  @if (features.length > 0) {
    <ul ngbNav #nav="ngbNav" class="nav-tabs">
      <li ngbNavItem>
        <a ngbNavLink>{{ 'AbpIdentity::IdentitySettingsPasswordPolicy' | abpLocalization }}</a>
        <ng-template ngbNavContent>
          <abp-identity-password-policy />
        </ng-template>
      </li>
      <li ngbNavItem>
        <a ngbNavLink>{{ 'AbpIdentity::IdentitySettingsLockout' | abpLocalization }}</a>
        <ng-template ngbNavContent>
          <abp-identity-lockout />
        </ng-template>
      </li>
      <li ngbNavItem>
        <a ngbNavLink>{{
          'AbpIdentity::IdentitySettingsIdentityVerification' | abpLocalization
        }}</a>
        <ng-template ngbNavContent>
          <abp-identity-verification />
        </ng-template>
      </li>
      <li ngbNavItem>
        <a ngbNavLink>{{ 'AbpIdentity::IdentitySettingsUserProfile' | abpLocalization }}</a>
        <ng-template ngbNavContent>
          <abp-identity-user-profile />
        </ng-template>
      </li>
      <li ngbNavItem>
        <a ngbNavLink>{{ 'AbpIdentity::Sessions' | abpLocalization }}</a>
        <ng-template ngbNavContent>
          <abp-identity-session-setting />
        </ng-template>
      </li>

      @for (feature of features; track $index) {
        <li ngbNavItem>
          <a ngbNavLink>
            {{
              (feature === externalLoginKey
                ? 'AbpIdentity::IdentitySettingsOAuth'
                : 'AbpIdentity::IdentitySettingsLdap'
              ) | abpLocalization
            }}
          </a>
          <ng-template ngbNavContent>
            @if (feature === externalLoginKey) {
              <abp-external-login-settings />
            } @else {
              <cai-ldap-login-settings></cai-ldap-login-settings>
            }
          </ng-template>
        </li>
      }
    </ul>
    <div [ngbNavOutlet]="nav"></div>
  } @else {
    <abp-identity-settings />
  }
</div>
